const mn = '[cynqueModules/onWindowFocus.ts]'

type TOnFocusCallback = (focused?: boolean) => void

type TState = {
  inDebounceInterval: boolean
  callbacks: TOnFocusCallback[]
}

const state: TState = {
  inDebounceInterval: false,
  callbacks: [],
}

export function onWindowFocus(newCallback: TOnFocusCallback) {
  if (
    !state.callbacks.find(
      (callback) => callback.toString() === newCallback.toString()
    )
  ) {
    state.callbacks.push(newCallback)
  }
  start()
}

export function removeWindowOnFocusListener() {
  const fn = `${mn} removeWindowOnFocusListener |`
  console.debug(`${fn} removing window onFocus listener`)
  window.removeEventListener('focus', handleWindowOnFocus)
}

function start() {
  const fn = `${mn} start |`
  state.inDebounceInterval = false
  console.debug(
    `${fn} Going to add onWindowFocus listener. (Removing first, just in case one exists.)`
  )
  removeWindowOnFocusListener()
  addWindowOnFocusListener()
}

function startDebounceInterval() {
  state.inDebounceInterval = true
  setTimeout(clearInDebounceInterval, 2000)
}

function clearInDebounceInterval() {
  state.inDebounceInterval = false
}

function addWindowOnFocusListener() {
  const fn = `${mn} addWindowOnFocusListener |`
  console.debug(`${fn} adding window onFocus listener`)
  window.addEventListener('focus', handleWindowOnFocus)
}

function handleWindowOnFocus() {
  const fn = `${mn} handleWindowOnFocus |`
  console.debug(`${fn} handleWindowOnFocus called`)
  if (state.inDebounceInterval) {
    console.debug(`${fn} in debounce interval`)
  } else {
    console.debug(`${fn} -NOT- in debounce interval. Calling callbacks.`)
    startDebounceInterval()
    console.debug(state.callbacks)
    state.callbacks.forEach((callback) => callback(true))
  }
}
